import { encryptStorage } from './storage';

const authorizeOn = () => {
  const userSession = encryptStorage.getItem('userSession');

  if (userSession === undefined) {
    return false;
  }
  return userSession['is_global_admin?'];
};

export default authorizeOn;
